<template>
  <div>
    <VSheet
      v-for="(vacancy, index) in filteredVacancies"
      :key="vacancy.id"
      elevation="0"
      tile
      class="my-3 my-md-6 font-weight-regular"
    >
      <CompanyVacanciesListRow :company-id="companyId" :vacancy="vacancy" />
      <VDivider
        v-show="(index < filteredVacancies.length - 1)"
        class="mt-3"
      />
    </VSheet>
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import CompanyVacanciesListRow from './CompanyVacanciesListRow.vue';

export default {
  name: 'CompanyVacanciesList',
  components: { CompanyVacanciesListRow },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    vacancies: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const { vacancies } = toRefs(props);

    const filteredVacancies = computed(() => vacancies.value.filter(vacancy => vacancy.visibility !== 'invitation'));

    return {
      filteredVacancies,
    };
  },
};
</script>
